import { collection, getDocs, limit, query } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';

export async function fetchClientsForPicker(appId, initialLimit = 200) {
  const clientsRef = collection(db, 'artifacts', appId, 'public', 'data', 'clients');
  const q = query(clientsRef, limit(initialLimit));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ ...d.data(), id: d.id }));
}
